import { apiClient } from '@/services/api/apiClient';
import { API_ENDPOINTS } from '@/constants/endpoints';

export const newsService = {
  getTopNews: async () => {
    return await apiClient.get(API_ENDPOINTS.NEWS.TOP_5);
  },

  getAllNews: async (page = 1, limit = 10, search?: string) => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (search) params.append('search', search);
    return await apiClient.get(`${API_ENDPOINTS.NEWS.ALL}?${params.toString()}`);
  },

  getNewsById: async (id: string) => {
    return await apiClient.get(API_ENDPOINTS.NEWS.DETAIL(id));
  },

  createNews: async (data: any) => {
    return await apiClient.post(API_ENDPOINTS.NEWS.CREATE, data);
  },

  updateNews: async (id: string, data: any) => {
    return await apiClient.put(API_ENDPOINTS.NEWS.DETAIL(id), data);
  },

  deleteNews: async (id: string) => {
    return await apiClient.delete(API_ENDPOINTS.NEWS.DETAIL(id));
  }
};
